import { render, staticRenderFns } from "./RiskAssessmentCoolingNetworkForm.vue?vue&type=template&id=6b49af2d"
import script from "./RiskAssessmentCoolingNetworkForm.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentCoolingNetworkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports